import { useEffect, useRef, useState } from "react";

export const useElementSize = () => {
  const ref = useRef(null);
  const [size, setSize] = useState({ w: 0, h: 0 });
  useEffect(() => {
    if (!ref.current) return;
    const ro = new ResizeObserver(([e]) => setSize({ w: e.contentRect.width, h: e.contentRect.height }));
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return [ref, size];
};

export const PhoneFrame = ({ children, className = "" }) => (
  <div className="min-h-[100dvh] w-full bg-[#0A2540] sm:py-0">
    <div className={`game-root relative mx-auto w-full max-w-[480px] overflow-hidden bg-[#EAF7F5] ${className}`}>{children}</div>
  </div>
);
